<div class="auth-wrap">
  <div class="card">
    <div class="brand">
      <img src="/assets/logo-horizontal.svg" alt="Waitora" />
    </div>

    <h2>{{ 'auth.register.title' | translate }}</h2>

    <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
      <!-- Nom -->
      <label for="lastName" class="required">{{ 'auth.register.lastNameLabel' | translate }}</label>
      <input
        id="lastName"
        type="text"
        formControlName="lastName"
        [class.invalid]="form.get('lastName')?.invalid && form.get('lastName')?.touched"
        [attr.aria-invalid]="form.get('lastName')?.invalid || null"
        autocomplete="family-name"
        required
      />
      <small class="field-error" *ngIf="form.get('lastName')?.hasError('required') && form.get('lastName')?.touched">
        {{ 'auth.register.lastNameRequired' | translate }}
      </small>

      <!-- Prénom -->
      <label for="firstName" class="required">{{ 'auth.register.firstNameLabel' | translate }}</label>
      <input
        id="firstName"
        type="text"
        formControlName="firstName"
        [class.invalid]="form.get('firstName')?.invalid && form.get('firstName')?.touched"
        [attr.aria-invalid]="form.get('firstName')?.invalid || null"
        autocomplete="given-name"
        required
      />
      <small class="field-error" *ngIf="form.get('firstName')?.hasError('required') && form.get('firstName')?.touched">
        {{ 'auth.register.firstNameRequired' | translate }}
      </small>

      <!-- Email -->
      <label for="email" class="required">{{ 'auth.register.emailLabel' | translate }}</label>
      <input
        id="email"
        type="email"
        formControlName="email"
        [class.invalid]="form.get('email')?.invalid && form.get('email')?.touched"
        [attr.aria-invalid]="form.get('email')?.invalid || null"
        autocomplete="email"
        required
      />
      <small class="field-error" *ngIf="form.get('email')?.hasError('required') && form.get('email')?.touched">
        {{ 'auth.register.emailRequired' | translate }}
      </small>
      <small class="field-error" *ngIf="form.get('email')?.hasError('email') && form.get('email')?.touched">
        {{ 'auth.register.emailInvalid' | translate }}
      </small>

      <!-- Mot de passe -->
      <label for="password" class="required">{{ 'auth.register.passwordLabel' | translate }}</label>
      <div class="password-field">
        <input
          id="password"
          [type]="showPassword ? 'text' : 'password'"
          formControlName="password"
          minlength="8"
          [class.invalid]="form.get('password')?.invalid && form.get('password')?.touched"
          [attr.aria-invalid]="form.get('password')?.invalid || null"
          autocomplete="new-password"
          required
        />
        <button 
          type="button" 
          class="password-toggle" 
          (click)="togglePasswordVisibility()"
          tabindex="-1"
        >
          <svg *ngIf="!showPassword" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
            <circle cx="12" cy="12" r="3"/>
          </svg>
          <svg *ngIf="showPassword" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
            <line x1="1" y1="1" x2="23" y2="23"/>
          </svg>
        </button>
      </div>
      <small class="field-error" *ngIf="form.get('password')?.hasError('required') && form.get('password')?.touched">
        {{ 'auth.register.passwordRequired' | translate }}
      </small>
      <small class="field-error" *ngIf="form.get('password')?.hasError('minlength') && form.get('password')?.touched">
        {{ 'auth.register.passwordMinlength' | translate }}
      </small>

      <!-- Organisation -->
      <label for="orgName" class="required">{{ 'auth.register.orgNameLabel' | translate }}</label>
      <input
        id="orgName"
        type="text"
        formControlName="orgName"
        [class.invalid]="form.get('orgName')?.invalid && form.get('orgName')?.touched"
        [attr.aria-invalid]="form.get('orgName')?.invalid || null"
        autocomplete="organization"
        required
      />
      <small class="field-error" *ngIf="form.get('orgName')?.hasError('required') && form.get('orgName')?.touched">
        {{ 'auth.register.orgNameRequired' | translate }}
      </small>

      <!-- Établissement -->
      <label for="establishmentName" class="required">{{ 'auth.register.establishmentNameLabel' | translate }}</label>
      <input
        id="establishmentName"
        type="text"
        formControlName="establishmentName"
        [class.invalid]="form.get('establishmentName')?.invalid && form.get('establishmentName')?.touched"
        [attr.aria-invalid]="form.get('establishmentName')?.invalid || null"
        autocomplete="organization"
        required
      />
      <small class="field-error" *ngIf="form.get('establishmentName')?.hasError('required') && form.get('establishmentName')?.touched">
        {{ 'auth.register.establishmentNameRequired' | translate }}
      </small>

      <!-- Erreur API -->
      <p class="error" *ngIf="apiError">{{ apiError }}</p>

      <!-- Actions -->
      <button type="submit" [disabled]="loading || form.invalid">
        {{ loading ? ('auth.register.submitLoading' | translate) : ('auth.register.submit' | translate) }}
      </button>

      <button type="button" class="secondary" (click)="cancel()" [disabled]="loading">{{ 'auth.register.cancel' | translate }}</button>
    </form>
  </div>
</div>
